import axios from '@/libraries/axios/main';

import Selected from '@/models/search/filter/Selected';
import ApiResponseOld from '@/interfaces/ApiResponseOld';

export async function fetchResult(selected: Selected): Promise<ApiResponseOld> {
  const response = await axios.post('/search/result', {
    // @ts-ignore
    affairs: selected.affairs,
    // @ts-ignore
    sessions: selected.sessions,
    // @ts-ignore
    category: selected.category,
    // @ts-ignore
    groups: selected.groups,
    // @ts-ignore
    protocols: selected.protocols,
  });

  return response.data;
}

export async function fetchFilters(): Promise<ApiResponseOld> {
  const response = await axios.get('/search/filter');

  return response.data;
}
